export const AssetGroupSearchTheme = {
  parent: 'AssetGroup',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Asset Group Search Theme',
    },
    AssetGroupSearchThemeId: {
      'bulk-upload-header': 'Id',
    },
    SearchTheme: {
      'bulk-upload-header': 'Search Theme',
    },
    AssetGroupId: {
      'bulk-upload-header': 'Parent ID',
    },
    Status: {
      'bulk-upload-header': 'Status',
    },
  },
};
